import { levelMap, LevelType } from '@/components/common/k-score/get-level'
import {
  type KpiSchema,
  type PerformanceQuartileMetrics,
} from '@/types/schema/kpi-schema'
import { PlatformShortcode } from '@/utils/convert-platform'

type PerformanceMetric = Pick<
  KpiSchema,
  | 'interactiveRatePerformance3m'
  | 'avgPvRatePerformance3m'
  | 'fansUpRatePerformance3m'
  | 'avgShortViewRatePerformance3m'
  | 'avgShortEngagementRatePerformance3m'
  | 'avgCommentLikeRatePerformance3m'
  | 'interactiveRatePerformance6m'
  | 'avgPvRatePerformance6m'
  | 'fansUpRatePerformance6m'
  | 'avgShortViewRatePerformance6m'
  | 'avgShortEngagementRatePerformance6m'
  | 'avgCommentLikeRatePerformance6m'
>
export const mockKolMetricPerformanceData: Record<
  | PlatformShortcode.Facebook
  | PlatformShortcode.Instagram
  | PlatformShortcode.YouTube,
  PerformanceMetric
> = {
  yt: {
    avgPvRatePerformance3m: {
      pr25: 0.1268308130081301,
      pr50: 0.3553842797292942,
      pr75: 0.9687521582733813,
    },
    interactiveRatePerformance3m: {
      pr25: 0.0007,
      pr50: 0.0019396897220426632,
      pr75: 0.004281900432420446,
    },
    fansUpRatePerformance3m: {
      pr25: 0,
      pr50: 0.00796812749003984,
      pr75: 0.02247191011235955,
    },
    avgCommentLikeRatePerformance3m: {
      pr25: 0.028221166612574868,
      pr50: 0.043208619198132764,
      pr75: 0.06928461977586155,
    },
    avgShortEngagementRatePerformance3m: {
      pr25: 0.00029342857142857144,
      pr50: 0.0006077939529675252,
      pr75: 0.0026248618784530386,
    },
    avgShortViewRatePerformance3m: {
      pr25: 0.011481877022653722,
      pr50: 0.021804558011049725,
      pr75: 0.06354153005464482,
    },
    avgPvRatePerformance6m: {
      pr25: 0.4359453133822699,
      pr50: 0.9279669831223629,
      pr75: 2.9335088607594937,
    },
    interactiveRatePerformance6m: {
      pr25: 0.0006849791925963822,
      pr50: 0.002383658914728682,
      pr75: 0.004596604215456675,
    },
    fansUpRatePerformance6m: {
      pr25: 0.005780346820809248,
      pr50: 0.018518518518518517,
      pr75: 0.04132231404958678,
    },
    avgCommentLikeRatePerformance6m: {
      pr25: 0.028321292498594657,
      pr50: 0.04085535819650451,
      pr75: 0.057919621749408984,
    },
    avgShortEngagementRatePerformance6m: {
      pr25: 0.00043735521235521236,
      pr50: 0.0012885646973541138,
      pr75: 0.003795002357378595,
    },
    avgShortViewRatePerformance6m: {
      pr25: 0.012814285714285714,
      pr50: 0.04084962686567164,
      pr75: 0.08457701043585021,
    },
  },
  ig: {
    avgPvRatePerformance3m: {
      pr25: 0.1262285517618236,
      pr50: 0.5683295346945137,
      pr75: 1.4001127161485056,
    },
    interactiveRatePerformance3m: {
      pr25: 0.0037264822672819103,
      pr50: 0.011827822322801478,
      pr75: 0.02630906495409018,
    },
    fansUpRatePerformance3m: {
      pr25: -0.0037880418749651175,
      pr50: 0.0010692150399666301,
      pr75: 0.018320115356885363,
    },
    avgCommentLikeRatePerformance3m: {
      pr25: 0.0036355155346261764,
      pr50: 0.0062598079371502455,
      pr75: 0.012649133576359477,
    },
    avgShortEngagementRatePerformance3m: {
      pr25: 0.002303033294261805,
      pr50: 0.006920147978644836,
      pr75: 0.017909950806949435,
    },
    avgShortViewRatePerformance3m: {
      pr25: 0.0181075486716074,
      pr50: 0.04299832128742713,
      pr75: 0.11619966325803084,
    },
    avgPvRatePerformance6m: {
      pr25: 0.45471233399625177,
      pr50: 1.136298136053073,
      pr75: 2.9780354606105086,
    },
    interactiveRatePerformance6m: {
      pr25: 0.004444926590311373,
      pr50: 0.01352494326927116,
      pr75: 0.027937229437229438,
    },
    fansUpRatePerformance6m: {
      pr25: -0.008233243890155152,
      pr50: 0.007494711792338476,
      pr75: 0.03503349882400368,
    },
    avgCommentLikeRatePerformance6m: {
      pr25: 0.003630875837761661,
      pr50: 0.006091297262732317,
      pr75: 0.013146946247295723,
    },
    avgShortEngagementRatePerformance6m: {
      pr25: 0.00264245568557082,
      pr50: 0.007561278894316025,
      pr75: 0.01912464234100414,
    },
    avgShortViewRatePerformance6m: {
      pr25: 0.02395643655959577,
      pr50: 0.05600751420578088,
      pr75: 0.13433682166237693,
    },
  },
  fb: {
    avgPvRatePerformance3m: {
      pr25: 0.009244776622315017,
      pr50: 0.04795209769004906,
      pr75: 0.14681194593820412,
    },
    interactiveRatePerformance3m: {
      pr25: 0.00022503715045316605,
      pr50: 0.0011292263240219042,
      pr75: 0.003219202467913756,
    },
    fansUpRatePerformance3m: {
      pr25: -0.004470400897227671,
      pr50: -0.0014528926841394507,
      pr75: 0,
    },
    avgCommentLikeRatePerformance3m: {
      pr25: 0.02124759084285244,
      pr50: 0.03446115288220551,
      pr75: 0.06635765241065582,
    },
    avgShortEngagementRatePerformance3m: {
      pr25: null,
      pr50: null,
      pr75: null,
    },
    avgShortViewRatePerformance3m: {
      pr25: null,
      pr50: null,
      pr75: null,
    },
    avgPvRatePerformance6m: {
      pr25: 0.04724476730293013,
      pr50: 0.17860314409767847,
      pr75: 0.4937309889615769,
    },
    interactiveRatePerformance6m: {
      pr25: 0.0002565038327060738,
      pr50: 0.0013800145021110764,
      pr75: 0.0031852320769061924,
    },
    fansUpRatePerformance6m: {
      pr25: -0.008491996029520525,
      pr50: -0.0034746486764371666,
      pr75: 0.001669853813144829,
    },
    avgCommentLikeRatePerformance6m: {
      pr25: 0.022029474976972673,
      pr50: 0.03598522624885655,
      pr75: 0.07111253990620794,
    },
    avgShortEngagementRatePerformance6m: {
      pr25: null,
      pr50: null,
      pr75: null,
    },
    avgShortViewRatePerformance6m: {
      pr25: null,
      pr50: null,
      pr75: null,
    },
  },
}

export const mockKolMetricPerformanceNullData: PerformanceQuartileMetrics = {
  pr25: null,
  pr50: null,
  pr75: null,
}

export const mockKolPr = {
  interactiveRatePr: {
    prRange: LevelType.Good,
    rating: levelMap[LevelType.Good].levelI18nId,
    color: levelMap[LevelType.Good].scoreColor,
    pr: 50,
  },

  fansUpRatePr: {
    prRange: LevelType.Normal,
    rating: levelMap[LevelType.Normal].levelI18nId,
    color: levelMap[LevelType.Normal].scoreColor,
    pr: 50,
  },
  viewRatePr: {
    prRange: LevelType.Bad,
    rating: levelMap[LevelType.Bad].levelI18nId,
    color: levelMap[LevelType.Bad].scoreColor,
    pr: 50,
  },
  avgCommentLikeRatePr: {
    prRange: LevelType.Normal,
    rating: levelMap[LevelType.Normal].levelI18nId,
    color: levelMap[LevelType.Normal].scoreColor,
    pr: 50,
  },
  avgShortEngagementRatePr: {
    prRange: LevelType.Normal,
    rating: levelMap[LevelType.Normal].levelI18nId,
    color: levelMap[LevelType.Normal].scoreColor,
    pr: 50,
  },
}
